import VerifyForm from "../forms/verifyForm";

const VerifyFormWrapper = () => {
  return (
    <VerifyForm />
  );
};

export default VerifyFormWrapper;
